import {createReducer, createTypes} from 'reduxsauce'
import {merge} from 'ramda'
import celulaActions from './celulaRedux'

const types = createTypes(`
  CHANGE_FILTER
`)

const change = payload => ({type: types.CHANGE_FILTER, payload})

export default {
  change,
  selectLabels: labels => dispatch => {
    dispatch(change({labels}))
    dispatch(celulaActions.filter())
  }
}

const initialState = {
  labels: '',
  igreja: ''
}
export const reducer  = createReducer(initialState, {
  [types.CHANGE_FILTER]: (state, {payload}) => merge(state, payload)
})



// WEBPACK FOOTER //
// ./src/Redux/filterRedux.js